import { useState, useEffect, useRef } from 'react';
import { missionApi } from '../../api/mission.api';
import { useUI } from '../../store/UIContext';
import { PageHeader, Btn, Skeleton, EmptyState } from '../../components/ui/index';
import { EmojiBar } from '../../components/ui/EmojiPicker';
import { User } from '@phosphor-icons/react';

export default function MissionDefinitionPage() {
  const { addToast } = useUI();
  const [employees, setEmployees] = useState([]);
  const [selected, setSelected] = useState('');
  const [description, setDescription] = useState('');
  const descRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    missionApi.getDepartmentEmployeeStatus().then(r=>setEmployees(Array.isArray(r.data)?r.data:[])).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const submit = async () => {
    if (!selected) { addToast('یک کارمند انتخاب کنید', 'error'); return; }
    setSubmitting(true);
    try {
      await missionApi.addMission({ employee_id: selected, description });
      addToast('ماموریت تعریف شد', 'success');
      setSelected(''); setDescription('');
    } catch { addToast('خطا در تعریف ماموریت', 'error'); }
    setSubmitting(false);
  };

  const STATUS_COLOR = { available:'#15803d', busy:'#dc2626', offline:'#94a3b8' };

  return (
    <div className="fade-in">
      <PageHeader title="تعریف ماموریت"/>
      <div className="pj-split-grid pj-split-grid--wide">
        <div style={{background:'#fff',borderRadius:14,border:'1px solid rgba(35,58,122,0.1)',padding:24}}>
          <h3 style={{fontSize:14,fontWeight:700,color:'#0f172a',marginBottom:16}}>انتخاب کارمند</h3>
          {loading?<div style={{display:'flex',flexDirection:'column',gap:8}}>{[1,2,3].map(k=><Skeleton key={k} h={50} radius={10}/>)}</div>
          :employees.length===0?<EmptyState icon={<User size={44} weight="regular" />} title="کارمندی یافت نشد"/>
          :<div style={{display:'flex',flexDirection:'column',gap:8}}>
              {employees.map(e=>(
                <button key={e.id} onClick={()=>setSelected(e.id)} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',borderRadius:10,border:`2px solid ${selected===e.id?'#29AAE1':'#e2e8f0'}`,background:selected===e.id?'#EDF3FC':'#fff',cursor:'pointer',fontFamily:'inherit',textAlign:'right',transition:'all 0.15s'}}>
                  <div style={{width:10,height:10,borderRadius:'50%',background:STATUS_COLOR[e.status]||'#94a3b8',flexShrink:0}}/>
                  <span style={{fontSize:14,fontWeight:selected===e.id?700:500,color:selected===e.id?'#1B3068':'#334155'}}>{e.name||e.username}</span>
                  <span style={{marginRight:'auto',fontSize:11,color:'#94a3b8'}}>{e.status==='available'?'آزاد':e.status==='busy'?'مشغول':'آفلاین'}</span>
                </button>
              ))}
            </div>
          }
        </div>
        <div style={{background:'#fff',borderRadius:14,border:'1px solid rgba(35,58,122,0.1)',padding:24}}>
          <h3 style={{fontSize:14,fontWeight:700,color:'#0f172a',marginBottom:14}}>شرح ماموریت</h3>
          <textarea ref={descRef} value={description} onChange={e=>setDescription(e.target.value)} placeholder="شرح ماموریت را بنویسید..." rows={5} style={{width:'100%',padding:'10px 12px',border:'1.5px solid #e2e8f0',borderRadius:8,fontSize:13,outline:'none',fontFamily:'inherit',resize:'vertical',marginBottom:8,boxSizing:'border-box'}}/>
          <div style={{marginBottom:14}}><EmojiBar inputRef={descRef} value={description} onInsert={setDescription} /></div>
          <Btn onClick={submit} loading={submitting} style={{width:'100%',justifyContent:'center'}}>تعریف ماموریت</Btn>
        </div>
      </div>
    </div>
  );
}